export default {
  namespaced: true,
  state: {
    // 收件箱未读消息数量
    count: null,
    // 通知消息数据
    messageData: {},
  },
  mutations: {
    changeCount(state, payload) {
      console.log(payload);
      if (payload == 0) {
        state.count = null;
      } else {
        state.count = payload;
      }
    },
    messageDataChange(state, payload) {
      console.log(payload);
      state.messageData = payload;
    },
  },
};
